<template>
    <v-app id="path-viewer-extended-toolbar">
        <Header @change-language="resetWalkedPath"/>

        <v-main class="pt-10">
            <v-container>
                <v-row>
                    <v-col cols="12" md="9">
                        <v-container v-if="wPath.length > 0" class="text-right px-0">
                            <v-btn class="mr-8" text color="#0c5a61" @click="goBack">
                                <v-icon>mdi-chevron-left</v-icon>
                                <span style="font-size: 16px">{{$t('general.back')}}</span> 
                            </v-btn>
                            <v-btn text color="#0c5a61" @click="goHome">
                                <v-icon>mdi-restart</v-icon>
                                <span style="font-size: 16px">{{$t('general.reset')}}</span>
                            </v-btn>
                        </v-container>
                    </v-col>

                    <v-col cols="12" md="9">
                        <v-container v-if="isProductPage" class="pa-0 ma-0">
                            <v-container class="productTitle pa-0 ma-0 d-flex" >
                                <img src="@/assets/polyglass-soluzione.png" width="69" height="68" @load="dataLayerPush(productTitle)">
                                <h2 class="text-h2 ml-4">{{$t('pathViewer.recommendedSolution')}}</h2>
                            </v-container>

                            <v-container class="productSubtitle ma-0">
                                <h4 class="text-subtitle-1 pb-3 text-left">
                                    {{$t('pathViewer.clickPreview')}} 
                                    <v-btn class="goToProductButton" @click="clickOnIframe(productUrl)">Clicca qui</v-btn> 
                                </h4>
                            </v-container>

                            <v-container class="productContainer pa-0">
                                <iframe
                                    id="ifrm"
                                    :src="productUrl"
                                    width="100%"
                                    height="1080"
                                >
                                </iframe>
                                <div class="iframeOverlay" @click="clickOnIframe(productUrl)">
                                    <!-- <v-btn class="goToProductButton">Accedi</v-btn> -->
                                </div>
                            </v-container>
                        </v-container>

                        <v-container v-else class="pa-0 ma-0">
                            <div class="progressBar mb-6 mt-3">
                                <div class="innerProgress" :class="progressBarCssClass">
                                    <div class="numProdLeftTooltip">
                                        {{numProdLeft}} {{$t('pathViewer.solutionsFound')}} 
                                    </div>
                                    <v-btn color="#404040" fab />
                                </div>
                            </div>

                            <v-container class="questionTitle ma-0 d-flex ">
                                <span class="rounded-circle questionNumber">{{wPath.length + 1}}</span>
                                <h6 class="text-h6 py-3 ml-4">{{ walkedPathTitle }}</h6>
                                <v-dialog width="500" v-if="walkedPathQuestionDetails != null" v-model="questionDialog">
                                    <template v-slot:activator="{ on, attrs }" >
                                        <v-btn @mouseover="detailsQuestionHover = true" @mouseleave="detailsQuestionHover = false" color="grey lighten-2" text x-small v-bind="attrs" v-on="on" >
                                            <v-icon v-if="detailsQuestionHover" color="#ff952a" small >
                                                mdi-help-circle
                                            </v-icon>
                                            <v-icon v-else color="#006b69" small >
                                                mdi-help-circle-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                    <v-card>
                                        <v-card-title>{{$t('pathViewer.questionDetails')}}</v-card-title>
                                        <v-card-text class="text-left"> {{ walkedPathQuestionDetails }} </v-card-text>
                                        <v-card-actions class="justify-end">
                                            <v-btn color="#ff952a" text @click="questionDialog = false" >
                                                {{$t('general.close')}}
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-container>

                            <v-container>
                                <v-row>
                                    <v-col v-for="(elem, i) in elementsList" :key="i" cols="12" md="4" >
                                        <v-card height="220">
                                            <v-card-text class="responseCardText pa-0">
                                                <v-container @click.self="selectElem(elem)" style="cursor:pointer; min-height: 53px;" class="pa-0 pt-2 d-flex justify-center">
                                                    <img class="primaryIcon" height="70" :src="`data:image/png;base64, ${elem.primary_icon_base64}`" v-if="elem.primary_icon_base64" />
                                                    <img class="secondaryIcon" @click.self="selectElem(elem)" height="70" :src="`data:image/png;base64, ${elem.secondary_icon_base64}`" v-if="elem.secondary_icon_base64" />
                                                </v-container>
                                                
                                                <v-container class="pt-2 text-center font-weight-bold" @click.self="selectElem(elem)" style="cursor:pointer; height: 167px">
                                                    {{ elem.text }}
                                                </v-container>

                                                <div v-if="elem.details" class="text-right infoResponseButton" >
                                                    <v-btn small elevation="0" tile dark color="#c6c6c6" @click="showAnswerDetailsDialog(elem)">
                                                        <v-icon small>
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </v-btn>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    
                                    <v-dialog width="500" v-model="detailsAnswerDialog">
                                        <v-card>
                                            <v-card-title>{{$t('pathViewer.answerDetails')}}</v-card-title>
                                            <v-card-text class="text-left">
                                                {{actualAnswerDetails}}
                                            </v-card-text>
                                            <v-card-actions class="justify-end">
                                                <v-btn color="#ff952a" text @click="detailsAnswerDialog = false" >
                                                    {{$t('general.close')}}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                </v-row>
                            </v-container>
                        </v-container>
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-card class="mx-auto px-0" max-width="400" elevation="0" color="#efefef">
                            <v-card-title class="riepilogoTitle pa-0">{{$t('pathViewer.summary')}}</v-card-title>
                            <v-card-text class="text-left pa-0">
                                <v-timeline dense>
                                        <v-timeline-item
                                            v-for="q in breadCrumbsList"
                                            :key="q.text"
                                            small
                                            class="walked-path"
                                            fill-dot
                                            color="#006b69"
                                        >
                                            <template v-slot:icon>
                                            <!-- Make the dot clickable -->
                                                <v-btn
                                                    small
                                                    icon
                                                    color="#006b69"
                                                    @click="goToSpecificWalkedPath(q.wPath)"
                                                >
                                                    <v-icon>mdi-checkbox-blank-circle</v-icon>
                                                </v-btn>
                                            </template>
                                            <span
                                                class="walked-path"
                                                @click="goToSpecificWalkedPath(q.wPath)"
                                                >{{ q.text }}
                                            </span>
                                        </v-timeline-item>
                                </v-timeline>
                            </v-card-text>
                        </v-card>

                        <v-card v-if="isProductPage" class="mt-5 mx-auto px-0" max-width="400" elevation="0" color="#efefef">
                            <v-card-title class="riepilogoTitle pa-0">{{$t('pathViewer.recommendedSolution')}}</v-card-title>
                            <v-card-text class="text-left pa-0">
                                <v-container class="productTitleBox mx-0 mt-2 pa-5">
                                    {{productTitle}}
                                    <v-btn class="mt-3" rounded small dark color="#006b69" @click="goHome" elevation="0">
                                        <v-icon style="font-size: 15px">mdi-restart</v-icon>
                                        <span style="font-size: 10px">{{$t('pathViewer.repeat')}}</span>
                                    </v-btn>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" md="9">
                        <v-container v-if="wPath.length > 0" class="text-right px-0">
                            <v-btn class="mr-8" text color="#0c5a61" @click="goBack">
                                <v-icon>mdi-chevron-left</v-icon>
                                <span style="font-size: 16px">{{$t('general.back')}}</span> 
                            </v-btn>
                            <v-btn text color="#0c5a61" @click="goHome">
                                <v-icon>mdi-restart</v-icon>
                                <span style="font-size: 16px">{{$t('general.reset')}}</span>
                            </v-btn>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>

        <Footer />
        
    </v-app>
</template>

<script>
import Api from "@/services/Api.js";
import { pathView as pathViewConfig } from "@/../config/index.js";
import Header from "./Header"
import Footer from "./Footer"

export default {
    props: ['wPathInit', 'wQuestionsInit'],
    components: { Header, Footer },
    name: "PathViewer",
    data() {
        return {
            skipSingleProduct: pathViewConfig.skipSingleProduct, // constant
            detailsQuestionHover: false,

            numProdLeft: 0,
            progressBarCssClass: '',
            questionDialog: false,
            msg: "",
            elementsList: [],
            walkedPathTitle: "",
            wPath: [],
            wQuestions: [],
            currentQuestion: {},
            walkedPathQuestionDetails: "",
            actualAnswerDetails:'',
            detailsAnswerDialog: false,

            isProductPage: false,
            productUrl: "",
            productTitle: ""
        };
    },

    computed:{
        breadCrumbsList(){
            return this.wQuestions.filter(function(item) {
                return item.text != 'Lista Prodotti'
            })
        }
    },

    methods: {
        clickOnIframe(productUrl){
            window.open(productUrl, '_blank').focus();
        },

        checkLastCrumb(text){
            if(text != 'Lista Prodotti') return true

            return false
        },

        showAnswerDetailsDialog(answerElement){
            this.actualAnswerDetails = answerElement.details
            this.detailsAnswerDialog = true
        },

        goToWalkedPath() {
            // console.log('this.wPath: ' + this.wPath)
            // console.log('this.wQuestions: ' + JSON.stringify( this.wQuestions))
            this.isProductPage = false;
            Api.listPublicCwd({ walkedPath: this.wPath, lang: this.$store.state.locale }) // walkedPath: ["A1"]
                .then((response) => {
                    this.formatData(response);
                })
                .catch((error) => {
                    this.msg = "An ERROR occurred: " + error;
                    alert(error);
                });
        },

        goToSpecificWalkedPath(walkedPath){
            this.wPath = walkedPath
            let new_wQuestion = []
            new_wQuestion = this.wQuestions.filter(function(item){
                return item.wPath.length < walkedPath.length
            })
            this.wQuestions = [...new_wQuestion]
            this.goToWalkedPath()
        },

        resetWalkedPath() {
            this.wPath = [this.wPathInit];
            this.goToWalkedPath();
            this.wQuestions = [this.wQuestionsInit];

            // Google Tag Manager Script
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'reset-click'
            });
            // End Google Tag Manager Script

        },

        goHome() {
            this.$router.push('/')
        },

        goBack() {
            if (!this.isProductPage) {
                this.wPath.pop();
                this.wQuestions.pop();
            }
            // twice because goToWalkedPath will add it up again
            this.wQuestions.pop();

            if (this.elemType === "Products") {
                if(this.skipSingleProduct && this.elementsList.length === 1) {
                    this.wPath.pop();
                    this.wQuestions.pop();
                }
            }

            this.goToWalkedPath();
        },

        selectElem(elem) {
            let elemValue = elem.url
            if (this.elemType === "Qa") {
                // 1. if type Qa perform here a POST to lsPublicCwd with the walkedPath + elemValue
                this.wPath.push(elemValue);
                this.goToWalkedPath();
            } else if (this.elemType === "Products") {

                // 2. if type Products

                // there are two options:

                // Either 2.1 open a new tab with Product URL
                // window.open(elemValue, "_blank").focus();

                // Or 2.2 enable iframe
                this.productUrl = elemValue;
                this.productTitle = elem.text;
                this.isProductPage = true;
            }
        },

        formatData(response) {
            this.msg = `HTTP Code: ${response.status} -- `;

            if (response.data.err == null) {
                this.msg += `Elements retrieved correctly: `;
                this.msg += JSON.stringify(response.data.res);

                this.elemType = response.data.res.type;

                if (this.elemType === "Qa") {
                    this.numProdLeft = response.data.res.numProdLeft;
                    this.progressBarCssClass = `step_${this.wPath.length}`
                    let qText = response.data.res.data[0].q_text;
                    const qCode = response.data.res.data[0].q_code;
                    this.currentQuestion["text"] = qText;
                    this.currentQuestion["code"] = qCode;
                    const textLimit = 66;
                    if (qText.length > textLimit) {
                        qText = qText.slice(0, textLimit) + "...";
                    }
                    // this.wQuestions.push(qText);
                    this.wQuestions.push({'text': qText, 'wPath': [...this.wPath]});
                    this.walkedPathTitle =
                        // response.data.res.data[0].q_code +
                        // " - " +
                        response.data.res.data[0].q_text;
                    this.walkedPathQuestionDetails =
                        response.data.res.data[0].q_details;
                    this.elementsList = response.data.res.data.map((obj) => {
                        let rObj = {};
                        rObj["hover"] = false;
                        rObj["text"] = obj.a_text;
                        rObj["url"] = obj.a_code;
                        rObj["details"] = obj.a_details;
                        rObj["primary_icon_name"] = obj.a_primary_icon_name;
                        rObj["primary_icon_base64"] = obj.a_primary_icon_b64;
                        rObj["secondary_icon_name"] = obj.a_secondary_icon_name;
                        rObj["secondary_icon_base64"] = obj.a_secondary_icon_b64;
                        return rObj;
                    });
                } else if (this.elemType === "Products") {
                    this.numProdLeft = response.data.res.numProdLeft;
                    this.progressBarCssClass = `step_final`
                    const name = "Lista Prodotti";
                    this.walkedPathQuestionDetails = "";
                    this.walkedPathTitle = name;
                    // this.wQuestions.push(name);
                    this.wQuestions.push({text: name, wPath: this.wPath});
                    this.elementsList = response.data.res.data.map((obj) => {
                        let rObj = {};
                        rObj["hover"] = false;
                        rObj["text"] = obj.code + " - " + obj.title;
                        rObj["url"] = obj.url;
                        return rObj;
                    });

                    if(this.skipSingleProduct && this.elementsList.length === 1) {
                        this.selectElem(this.elementsList[0]);
                    }
                }
            } else {
                // this is reached only when HTTP code is 200 and response.data.err is not null
                this.msg = "ERROR: " + response.data.err;
            }
            this.msg += " -- " + JSON.stringify(this.elementsList);
        },

        // Google Tag Manager Script
        dataLayerPush(productTitle) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'result-viewed',
                'product': productTitle
            });
        }

    },

    created() {
        // Initialize form answers/products

        this.wPath = [this.wPathInit];
        this.wQuestions = [this.wQuestionsInit]; //{"text":"Scelta della copertura","wPath":["0a"]}
        this.goToWalkedPath();
    },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.productContainer{
    position: relative;
}
.iframeOverlay{
    position: absolute;
    top: 0;
    height: 1080px;
    width: 100%;
    cursor: pointer;
}

.iframeOverlay::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #0c5a61;
    opacity: 0;
    z-index: 0;
    transition: opacity 0.3s ease;
}

.iframeOverlay:hover::before{
    background: #0c5a61;
    opacity: 0.2;
}

.iframeOverlay .goToProductButton, .goToProductButton{
    position: relative;
    background-color: #ff952a !important;
    color: #ffffff !important;
    font-weight: bold;
    font-size: 1.1em;
    /* margin-top: 15px; */
}

.iframeOverlay .goToProductButton:hover, .goToProductButton:hover {
    background-color: #e67e00;
    transform: scale(1.05);
}


#path-viewer-extended-toolbar{
    font-family: 'Montserrat' !important;
    background: #efefef;
}

.rounded-circle{
    width: 70px;
    min-width: 70px;
    max-height: 70px;
    display: inline-block;
    background-color: #006b69;
    font-size: 30px;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
    padding: 12px 0;
}

.walked-path {
    line-height: 12pt !important;
    cursor: pointer;
}

.responseCardText{
    text-align: left;
    height: 220px;
    color: #424242 !important;
}
.responseCardText .secondaryIcon{
    display: none;
}

.responseCardText:hover{
    position: relative;
    background: #0c5a61;
    color: white !important;
}
.responseCardText:hover .secondaryIcon{
    display: block;
}
.responseCardText:hover .primaryIcon{
    display: none;
}

.infoResponseButton{
    position: absolute;
    bottom: 0;
    right: 0;
}

.responseCardText:hover .infoResponseButton button{
    background: #ff952a !important;
}

/* .infoResponseButton:hover button{
    background: #ff952a !important;
} */

.progressBar{
    height: 11px;
    background-color: #ffffff;
    border-radius: 50px;
}

.innerProgress{
    background: rgb(197,197,197);
    background: linear-gradient(90deg, rgba(197,197,197,1) 0%, rgba(64,64,64,1) 100%);
    height: 100%;
    border-radius: 50px;
    position: relative;
}
.innerProgress.step_0{width: 18px;}
.innerProgress.step_1{width: 20%;}
.innerProgress.step_2{width: 40%;}
.innerProgress.step_3{width: 60%;}
.innerProgress.step_4{width: 80%;}
.innerProgress.step_final{width: 100%;}

.progressBar .innerProgress button{
    height: 18px !important;
    width: 18px !important;
    position: absolute;
    top: -4px;
    right: 0;
    cursor: auto;
}

.progressBar .innerProgress .numProdLeftTooltip{
    padding-top: 3px;
    position: absolute;
    right: 7px;
    top: -35px;
    background: url(../assets/polyglass_etichetta_avanzamento.png);
    height: 28px;
    width: 108px;
    font-size: 9px;
    font-weight: 500;
    color: #404040;
}
.progressBar .innerProgress.step_0 .numProdLeftTooltip{
    display: none;
}

.questionTitle {
    min-height: 100px;
}
.questionTitle .text-h6{
    font-family: 'Montserrat' !important;
}

.productTitle h2.text-h2{
    font-size: 40px !important;
    color: #404040;
    font-weight: 300 !important;
    line-height: 68px;
    font-family: 'Montserrat' !important;
}

.productSubtitle h4.text-subtitle-1{
    width: 100%;
    font-family: 'Montserrat' !important;
}

.riepilogoTitle{
    font-size: 20px;
    font-weight: 700;
    color: #404040;
}

.productTitleBox{
    background-color: #ff952a;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    width: 225px;
    border-radius: 14px !important;
    min-height: 150px;
    position: relative;
}

.productTitleBox button{
    position: absolute;
    bottom: 20px;
    left: 20px;
}
.productTitleBox button:hover{
    background: #404040 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/PathViewer.vue